import OffCanvas    from './offcanvas'
import OffCanvasNew    from './offcanvasNew'
import Footer       from './footer'
import Product      from './product'
import Slider       from './slider'
import ElasticImage from './elastic-image'

import UserLogin      from './user-popup/user-login'
import UserProfileMenu      from './user-popup/user-profile-menu'

import FavoritesProductEdit      from './favorites-products/favorites-product-edit'

import ProductPreview  from './product/preview'
import AddToCartButton from './cart/add-to-cart-button'
import RegisterForm    from './register-form'
import NewsletterPopup from './newsletter-popup'
import InView from './in-view'

export default {
  OffCanvas,
  OffCanvasNew,
  Footer,
  Product,
  Slider,
  ElasticImage,
  UserLogin,
  UserProfileMenu,
  AddToCartButton,
  ProductPreview,
  FavoritesProductEdit,
  RegisterForm,
  NewsletterPopup,
  InView
}
